import * as React from "react";
import { forwardRef } from "react";
const SvgOnboardProgressArrow = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 17, viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M4.0026 8.36212H12.3359M12.3359 8.36212L8.33594 4.36212M12.3359 8.36212L8.33594 12.3621", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgOnboardProgressArrow);
export { ForwardRef as ReactComponent };
